import { useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { getOrganizationSettings } from '../../../services/organization/OrganizationService';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useOrganizationSettingsList = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const loadAsync = async (organizationId: string) => {
    try {
      if (organizationId) {
        const { data } = await getOrganizationSettings(organizationId);
        setIsLoading(false);
        return data;
      }
    } catch (error) {
      handleError(error);
    }
    setIsLoading(false);
  };

  return {
    getOrganizationSettings: loadAsync,
    isLoading,
  };
};

export default useOrganizationSettingsList;
